<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="dedication" id="ded" role="doc-dedication">
<p class="dedf"><span aria-label=" Page v. " class="page" epub:type="pagebreak" id="pv" role="doc-pagebreak"></span>To Dr. Jane S. Zembaty and Dr. Patricia A. Johnson</p>
<p class="ded">for preparing the way</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-Fischer-OA-0005.vue?e44fe78e